import axios from "axios";
import React, { memo, useEffect, useState } from "react";
import { API_URL } from "../../../url/api";
import { isMeetingWithin10Minutes } from "../../../utils";
import { MdOutlineEdit } from "react-icons/md";
import { CountDown } from "../../../components/CalendarView/CountDown";
interface SessionData {
  id: number;
  room_id: string;
  title: string | null;
  duration: string | null;
  session_date: string | null;
  session_start_time: string | null;
  session_end_time: string | null;
  is_paid: boolean;
  is_completed: boolean;
  session_rating: number | null;
  session_feedback: string;
  video_url: string | null;
  is_video_available: boolean;
  session_status: string;
  updated_at: string;
  created_at: string;
  doctor: {
    id: number;
    created_at: string;
    user: number;
    therapist: number;
  };
  user: {
    id: number;
    name: string;
    email: string;
    password: string;
    created_at: string;
    user: number;
  };
  schedule_time: {
    id: number;
    date: string;
    doctor: number;
    slots: number[];
  };
  time_slot: {
    id: number;
    datetime: string;
  };
}

interface SessionDetailsProps {
  sessionId: number;
  isCompleted?: boolean;
}

interface InfoUIProps {
  title: string;
  data: string | null;
}

const SessionDetails: React.FC<SessionDetailsProps> = memo(
  ({ sessionId, isCompleted }) => {
    const [originalSessionData, setOriginalSessionData] =
      useState<SessionData | null>(null);

    const [sessionData, setSessionData] = useState<SessionData | null>(null);

    const [editNotes, setEditnote] = useState<boolean>(false);

    useEffect(() => {
      if (!sessionData) fetchSessionData();
    }, [sessionData]);

    const fetchSessionData = async () => {
      try {
        const response = await axios.get<SessionData>(
          `${API_URL}v2/sessions/${sessionId}/`
        );
        setSessionData(response.data);
        setOriginalSessionData(JSON.parse(JSON.stringify(response.data)));
      } catch (error) {
        console.error("Error fetching session data:", error);
      }
    };

    const InfoUI: React.FC<InfoUIProps> = React.memo(({ title, data }) => (
      <div>
        <p className="font-bold">{`${title} : `}</p>
        <p>{data || "N/A"}</p>
      </div>
    ));

    const handleSaveChanges = async () => {
      if (sessionData)
        try {
          const response = await axios.put<SessionData>(
            `${API_URL}v2/sessions/${sessionId}/`,
            sessionData
          );
          fetchSessionData();
          setEditnote(false);
        } catch (error) {
          console.log("🚀 ~ handleReschedule ~ error:", error);
        }
    };

    const isDataChanged =
      sessionData && originalSessionData
        ? JSON.stringify(sessionData) !== JSON.stringify(originalSessionData)
        : false;

    const dataList = sessionData
      ? [
          // { title: "Title", data: sessionData.title },
          // { title: "Duration", data: sessionData.duration },
          // { title: "Session Date", data: sessionData.session_date },
          // { title: "Session Start Time", data: sessionData.session_start_time },
          // { title: "Session End Time", data: sessionData.session_end_time },
          // { title: "Is Paid", data: sessionData.is_paid ? "Yes" : "No" },
          // {
          //   title: "Is Completed",
          //   data: sessionData.is_completed ? "Yes" : "No",
          // },
          // {
          //   title: "Session Rating",
          //   data: sessionData.session_rating?.toString(),
          // },
          // { title: "Session Feedback", data: sessionData.session_feedback },
          // { title: "Video URL", data: sessionData.video_url },
          // {
          //   title: "Is Video Available",
          //   data: sessionData.is_video_available ? "Yes" : "No",
          // },
          { title: "Session Status", data: sessionData.session_status },
        ]
      : [];

    const onSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
      console.log("🚀 ~ e:", e.target.value);
      if (sessionData) {
        sessionData.session_status = e.target.value;
        setSessionData({ ...sessionData });
      }
    };

    const onChangeNotes = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (sessionData) {
        sessionData.session_feedback = e.target.value;
        setSessionData({ ...sessionData });
      }
    };

    const handleNotes = () => setEditnote(!editNotes);

    if (sessionData)
      console.log(
        isMeetingWithin10Minutes(
          sessionData.time_slot.datetime
        ),
      );

    if (!sessionData) return <p>Loading session data...</p>;

    return (
      <div className="overflow-auto">
        <div className="bg-white shadow-md rounded-lg p-6 w-full mt-8 border border-gray-200">
          {/* <h3 className="text-lg font-bold mb-4">User Details</h3> */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <InfoUI title="Name" data={sessionData.user.name} />
            <InfoUI title="Email" data={sessionData.user.email} />
          </div>
        </div>

        <div className="bg-white mt-6 shadow-md rounded-lg p-6 w-full  border border-gray-200">
          {/* <div>
            <h3 className="text-lg font-bold mb-2">Schedule Time</h3> */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <InfoUI title="Date" data={sessionData.time_slot.datetime} />
            <InfoUI title="Time Slots" data={new Date(sessionData.time_slot.datetime).toLocaleTimeString('en-US',{ hour:'2-digit',minute:'2-digit', hour12:true }) } />
          </div>
          {/* </div> */}
        </div>

        <div className="bg-white shadow-md rounded-lg p-6 w-full mt-6 border border-gray-200 ">
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              {/* {dataList.map((info) => (
                <InfoUI
                  key={info.title}
                  title={info.title}
                  data={info.data || null}
                />
              ))} */}
              <div className="relative">
                <p className="font-bold">{`Session Status : `}</p>
                <select
                  name="status"
                  id="session_status"
                  value={sessionData.session_status}
                  onChange={onSelect}
                  className="appearance-none mt-2 bg-white px-4 py-2 border focus:outline-none  border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-base w-full text-gray-700 pr-8"
                >
                  <option value="scheduled" className="py-2">
                    Scheduled
                  </option>
                  <option value="rescheduled" className="py-2">
                    Rescheduled
                  </option>
                  <option value="completed" className="py-2">
                    Completed
                  </option>
                  <option value="cancelled" className="py-2">
                    Cancelled
                  </option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 pt-8 text-gray-700">
                  <svg
                    className="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                  </svg>
                </div>
              </div>
            </div>
            {isCompleted && (
              <div className="mt-6">
                <p className="font-bold mb-2">{`Notes : `}</p>
                {editNotes || sessionData.session_feedback === "" ? (
                  <textarea
                    placeholder="Notes.."
                    value={sessionData.session_feedback}
                    onChange={onChangeNotes}
                    className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                    rows={4}
                  />
                ) : (
                  <p className="flex items-center gap-2">
                    {sessionData.session_feedback || "N/A"}
                    <MdOutlineEdit
                      size={16}
                      onClick={handleNotes}
                      className="cursor-pointer"
                    />
                  </p>
                )}
              </div>
            )}
          </div>
        </div>

        {isDataChanged && (
          <div className="flex justify-end mt-6">
            <button
              className="bg-primary text-white w-full md:w-auto text-center px-4 py-2 rounded"
              onClick={handleSaveChanges}
            >
              Save Changes
            </button>
          </div>
        )}

        {!isCompleted &&
          // <CountDown meetingTime={`${sessionData.schedule_time.date}T${sessionData.time_slot.time}`} roomId={sessionData.room_id} />
            <div className="flex justify-end mt-6">
              <CountDown
                meetingTime={
                  sessionData.time_slot.datetime
                }
                roomId={sessionData.room_id} />
              {/* <a
                href={`/videocall?room_id=${sessionData.room_id}`}
                target="_blank"
                rel="noreferrer"
                className="bg-blue-500 text-white w-full md:w-auto text-center px-4 py-2 rounded"
              >
                Join Video Call
              </a> */}
            </div>
          }
      </div>
    );
  }
);

export default SessionDetails;
